/**
 * Gradient and grain definitions for the board styles. The chessboard is an
 * inline SVG, so CSS can fill its squares with `url(#id)` as long as the ids
 * exist somewhere in the document. This zero-size SVG provides them.
 */
export function BoardDefs() {
  return (
    <svg width="0" height="0" aria-hidden="true" focusable="false" style={{ position: "absolute" }}>
      <defs>
        <linearGradient id="f15m-walnut-light" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#edd8b3" />
          <stop offset="0.5" stopColor="#e5cda4" />
          <stop offset="1" stopColor="#dcc094" />
        </linearGradient>
        <linearGradient id="f15m-walnut-dark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#9c6a3e" />
          <stop offset="0.5" stopColor="#8c5c34" />
          <stop offset="1" stopColor="#7a4d2b" />
        </linearGradient>
        <radialGradient id="f15m-marble-light" cx="0.3" cy="0.25" r="1.1">
          <stop offset="0" stopColor="#f8f5ee" />
          <stop offset="0.55" stopColor="#f1ece2" />
          <stop offset="1" stopColor="#e6e0d3" />
        </radialGradient>
        <radialGradient id="f15m-marble-dark" cx="0.7" cy="0.75" r="1.1">
          <stop offset="0" stopColor="#b9c4bb" />
          <stop offset="0.6" stopColor="#a9b5ac" />
          <stop offset="1" stopColor="#97a39b" />
        </radialGradient>
        <linearGradient id="f15m-obsidian-light" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#929ca7" />
          <stop offset="1" stopColor="#838e99" />
        </linearGradient>
        <linearGradient id="f15m-obsidian-dark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#505b66" />
          <stop offset="1" stopColor="#434e59" />
        </linearGradient>
        <linearGradient id="f15m-slate-light" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#d4dbe0" />
          <stop offset="1" stopColor="#c9d1d7" />
        </linearGradient>
        <linearGradient id="f15m-slate-dark" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#74848f" />
          <stop offset="1" stopColor="#68798a" />
        </linearGradient>
      </defs>
    </svg>
  );
}
